export default __webpack_public_path__ + "static/media/arseniologo.c4caa905.png";